import React, { useEffect, useState } from 'react';
import { styled } from "../../../stitches.config";
import CustomSlider from './CustomSlider';
import { h1, p } from '../../commonStyles/Fonts';
import axios from "axios";
import JobOfferCard from './JobOfferCard';


let JOBOFFER_POSTS: any[] = [];

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 996,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            },
        }
    ]
};

const settingsOne = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const settingsTwo = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 996,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            },
        }
    ]
};

const Jobs = () => {

    const [jobOfferPosts, setJobOfferPosts] = useState<any[]>(JOBOFFER_POSTS);

    useEffect(() => {
        if (JOBOFFER_POSTS.length > 0)
            return;

        (async () => {
            let posts = [];
            try {
                const { data } = await axios.get(`${window.API_HOST}/api/posts/?displayType=ARTICLE_JOB_OFFER`);
                posts = data?.posts ?? [];
            } catch { }

            JOBOFFER_POSTS = posts;
            setJobOfferPosts(posts);
        })();
    }, []);


    return (
        <OpenJobs>
            <Header>
                <h1 className={h1()}>Otwarte procesy rekrutacyjne</h1>
                <p className={p()}>
                    Obecnie poszukujemy poniższych kandydatów. Jednak zawsze jesteśmy otwarci
                    na nowe talenty. Jeśli nie znajdziesz nic dla siebie i tak możesz do nas napisać, chętnie Cię poznamy!
                    Napisz do nas parę słów o sobie na <a href='mailto:praca@natemat.pl'><OrangeSpan>praca@natemat.pl</OrangeSpan></a>
                </p>
            </Header>
            {jobOfferPosts.length > 0 ?
                <JobsWrapper>
                    {jobOfferPosts.length === 1 &&
                        <CustomSlider {...settingsOne} className="jobsslider">
                            {jobOfferPosts.map(post => (
                                <JobOfferCard article={post} />
                            ))}
                        </CustomSlider>
                    }
                    {jobOfferPosts.length === 2 &&
                        <CustomSlider {...settingsTwo} className="jobsslider">
                            {jobOfferPosts.map(post => (
                                <JobOfferCard article={post} />
                            ))}
                        </CustomSlider>
                    }
                    {jobOfferPosts.length > 2 &&
                        <CustomSlider {...settings} className="jobsslider">
                            {jobOfferPosts.map(post => (
                                <JobOfferCard article={post} />
                            ))}
                        </CustomSlider>
                    }
                </JobsWrapper>
                :
                <Info className={p()}>Aktualnie brak ofert</Info>
            }
        </OpenJobs>
    )
}

export default Jobs;

const OpenJobs = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    backgroundColor: '$grayscale100Fixed',
    //height: '800px',
    marginTop: '40px',
    'p,h1': {
        color: '$grayscale0Fixed',
        textAlign: 'left',
    },
    '@bp4': {
        'p,h1': {
            color: '$grayscale0Fixed',
            textAlign: 'center',
        },
        gap: '72px',
        //height: '1200px',
        marginTop: '0px',
    }
})

const Info = styled('div', {
    color: '$grayscale0',
    marginBottom: "80px",
})

const Header = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    color: '$grayscale100',
    marginTop: '56px',
    marginBottom: '40px',
    textAlign: 'center',
    padding: '0px 16px 0px 16px',
    'h1': {
        margin: 0,
    },
    '@bp4': {
        width: '900px',
        marginTop: '168px',
        marginBottom: '72px',
    }
})


const JobsWrapper = styled('div', {
    width: '90%',
    height: '500px',
    '.slick-slider': {
        '.slick-list': {
            overflow: 'visible',
            '.slick-track': {
                display: 'flex',
                gap: '8px',
                '.slick-slide': {
                    height: '410px',
                    'div': {
                        height: '100%',
                    }
                }
            },
        },
        'ul': {
            transform: 'translateY(25px)',
            'li': {
                background: '$grayscale0Fixed',
                borderRadius: '50%',
                width: '10px',
                height: '10px',
                opacity: 0.1,
                'button': {
                    '&:before': {
                        content: ''
                    },
                },
                '&.slick-active': {
                    background: '$primary',
                    opacity: 1,
                },
            },
        },
        '.slick-arrow': {
            display: 'none',
        },
    },

    '@bp4': {
        '.slick-slider': {
            '.slick-list': {
                overflow: 'hidden',
                '.slick-track': {
                    display: 'flex',
                    gap: '24px',
                },
            },
            '.slick-next': {
                display: 'block',
                background: '$natematPrimary',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                zIndex: 100,
                transform: 'rotate(90deg) translate(-50%, 15px)',
                '&::before': {
                    content: '',
                },
                '&:hover': {
                    background: '$natematPrimary',
                    cursor: 'pointer',
                },
                'svg': {
                    transform: 'translate(50%,50%)',
                }
            },
            '.slick-prev': {
                display: 'block',
                background: '$natematPrimary',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                zIndex: 100,
                transform: 'rotate(-90deg) translate(50%, 15px)',
                '&::before': {
                    content: '',
                },
                '&:hover': {
                    background: '$natematPrimary',
                    cursor: 'pointer',
                },
                'svg': {
                    transform: 'translate(50%,50%)',
                }
            },

        },
    }
})


const OrangeSpan = styled('span', {
    color: '$natematPrimary',
})